<template>
	<div>
		<div class="report-content">
			<a :class="fontSize == 2 ? 'report-title' : fontSize == 1 ? 'report-title titleSmall' : 'report-title titleBig'"
				@click="openDocument(report.id, report.content,report.title)">
				<span :class="report.read ? 'article-title-off' : ''">{{ report.title }}</span>
			</a>
			<div class="report-text">
				<div v-if="report.new == true"><span class="report-text-new">New</span></div>
				<div
					:class="fontSize == 2 ? 'report-text-time' : fontSize == 1 ? 'report-text-time titleSmall' : 'report-text-time titleBig'">
					{{ report.createTime }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import store from "@/store"
import { onMounted, watch, ref } from "vue"
import { openDocument } from '../homePageComponent/js/index'
export default {
	name: "Report",
	props: {
		report: { type: Object, defalut: [] }
	},
	setup() {
		onMounted(() => {
			fontSize.value = store.getters.fontSize
		})
		watch(() => store.getters.fontSize, (val) => {
			fontSize.value = val
		})
		const fontSize = ref('')
		return {
			fontSize,
			openDocument
		}
	},
}
</script>
<style lang="scss" scoped>
.report-text-time.titleSmall {
	font-size: 12px;
}

.report-text-time.titleBig {
	font-size: 16px;
}

.report-content {
	a {
		color: #363839;
	}

	a:hover {
		color: #315efb;
	}
}

.report-content {
	padding-bottom: 5px;

	.report-title.titleSmall {
		font-size: 16px;
	}

	.report-title.titleBig {
		font-size: 20px;
	}

	.report-title {
		margin-top: 16px;
		font-size: 18px;
		font-weight: bold;

		// white-space: nowrap;
		// text-overflow: ellipsis;
		// overflow: hidden;
		// word-break: break-all;
		.report-title-off {
			font-weight: normal;
			// white-space: nowrap;
			// text-overflow: ellipsis;
			// overflow: hidden;
			// word-break: break-all;
			color: #a7adb0;
		}
	}

	.report-text {
		display: flex;
		color: #888e90;
		font-size: 14px;
		line-height: 44px;
		border-bottom: 2px solid #f3f3f5;
		align-items: center;

		.report-text-new {
			color: #ffffff;
			background-color: red;
			padding: 0 10px;
			border-radius: 20px;
			margin-right: 20px;
		}
	}
}</style>
